import paginationButtons from "./paginationButtons";
import stringDate from "./stringDate";
import formatOrgName from "./formatOrgName";
import formatPhone from "./formatPhone";
import generateAccount from "./generateAccount";
import getIncome from "./getIncome";
import pagination from "./paginationFunc";

const helpers = {
    paginationButtons,
    stringDate,
    formatOrgName,
    formatPhone,
    generateAccount,
    getIncome,
    pagination
}

export default helpers